import React from 'react';

import { useAppState } from '../../context/AppState';
import IntelNormal from '../Intel/IntelNormal';
//import IntelPinchZoom from '../Intel/IntelPinchZoom';

const Intel = () => {
  //const { appState } = useAppState();
  //return appState.usePinchZoom ? <IntelPinchZoom /> : <IntelNormal />;
  return <IntelNormal />;
};

export default Intel;
